import React from "react";

import Animated, {
  SharedValue,
  useDerivedValue,
} from "react-native-reanimated";
import { PageIndicatorWrapper } from "./PageIndicator";
import { useAHTextTypeStyles } from "arkh";
import ReText from "./ReText";

export function PageIndicatorAnimated(props: {
  currentPage: SharedValue<number>;
  numberOfItems: number;
}) {
  const text = useDerivedValue(() => props.currentPage.value + 1 + "");
  const textStyle = useAHTextTypeStyles("subtitle");
  return (
    <PageIndicatorWrapper numberOfItems={props.numberOfItems}>
      <ReText
        style={[textStyle.defaultStyle, { maxWidth: 15, textAlign: "right" }]}
        text={text}
      />
    </PageIndicatorWrapper>
  );
}
